import ENV from '../config/env';

/* eslint-disable no-console */

export default class Logger {
  static log(...messages) {
    this.fire('log', ...messages);
  }

  static debug(...messages) {
    if (ENV.debug) {
      this.fire('log', ...messages);
    }
  }

  static warn(...messages) {
    this.fire('warn', ...messages);
  }

  static error(...messages) {
    this.fire('error', ...messages);
  }

  static fire(handler, ...messages) {
    const prependedMessage = '[GWI BrickLayer]';
    console[handler](prependedMessage, ...messages);
  }
}



// WEBPACK FOOTER //
// ./src/utils/logger.js